module.exports = __webpack_public_path__ + "static/img/food-policy034.02a3a6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy034.png
// module id = m8CX
// module chunks = 1